import { Injectable, signal, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export type YoutubeSearchResult = {
  youtubeId: string;
  title: string;
  channel: string;
  duration: number;
  views: number;
  uploadedAt: string;
};

export type YoutubeThumbnail = {
  youtubeId: string;
  title: string;
  channel: string;
  duration: number;
  views: number;
  uploadedAt: string;
};

@Injectable({ providedIn: 'root' })
export class YoutubeService {
  private http = inject(HttpClient);

  // 🎯 Signalid!
  results = signal<YoutubeSearchResult[]>([]);
  loading = signal(false);
  error = signal<string | null>(null);

  /**
   * Durationiga otsimine kulutab rohkem minu igapäevaseid limiite
   * ja seega on see vaikimisi välja lülitatud.
   * @param query string mida otsitakse
   * @param duration kas otsida koos video durationiga
   */
  search(query: string, duration: boolean = true): void {
    if (!query || query.length < 2) {
      this.results.set([]);
      return;
    }

    this.loading.set(true);
    this.error.set(null);

    this.http
      .get<
        YoutubeSearchResult[]
      >(`${environment.apiUrl}/youtube-search${duration ? '-v3' : ''}?q=${encodeURIComponent(query)}`)
      .subscribe({
        next: videos => {
          this.results.set(videos);
          this.loading.set(false);
        },
        error: err => {
          console.error('❌ Search failed:', err);
          this.error.set('Failed to search videos');
          this.loading.set(false);
        },
      });
  }
}
